import { useEffect, useRef } from "react";
import { useInView } from "react-intersection-observer";
import { track } from "tracking/client";
import { mapGraphqlToSegmentTrackEvent } from "tracking/utils/mapGraphqlToSegmentEvent";
import type {
  Maybe,
  TrackExperimentViewedEventType,
  TrackingViewed
} from "@shared/graphql.types";
import { useInViewCount } from "./useInViewCount";

export const isExperimentViewedTracking = (
  tracking: TrackingViewed
): tracking is TrackExperimentViewedEventType =>
  tracking.event === "Experiment Viewed";

export const useTrackViewed = (
  viewedTracking: Maybe<TrackingViewed[]> | undefined,
  inViewedOptions?: {
    threshold: number;
    triggerOnce: boolean;
  }
) => {
  const { inView, ref, entry } = useInView(inViewedOptions);
  const hasTrackedRef = useRef(false);

  const numResultsViewed = useInViewCount(
    entry?.target,
    `[data-product-result="constructor"]`
  );

  useEffect(() => {
    if (inView && !hasTrackedRef.current && numResultsViewed != null) {
      viewedTracking
        ?.filter((tracking) => !isExperimentViewedTracking(tracking))
        .forEach((data) => {
          const trackingEvent = mapGraphqlToSegmentTrackEvent(data);

          //handle numResultsViewed
          if (
            trackingEvent?.event === "Product List Viewed" &&
            trackingEvent.properties.num_results_viewed
          ) {
            trackingEvent.properties.num_results_viewed = numResultsViewed;
          }

          if (trackingEvent) track(trackingEvent);
        });
      hasTrackedRef.current = true;
    }
  }, [inView, viewedTracking, numResultsViewed]);

  return {
    ref
  };
};
